// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import TaskSvg from '@rsuite/icon-font/lib/application/Task';
var Task = createSvgIcon({
  as: TaskSvg,
  ariaLabel: 'task',
  category: 'application',
  displayName: 'Task'
});
export default Task;